export const ALL_UUID = '00000000-0000-0000-0000-000000000000';

export const TRIAL_FOLLOW_UP_DAYS = [14, 7, 2, -7];

export const YEAR_END_MIN_DATE = new Date(2000, 0, 1);
export const YEAR_END_MAX_DATE = new Date(2000, 11, 31);

export const FONT_FAMILY = 'Inter, sans-serif';

export const IMAGE_UPLOAD_MAX_SIZE_KB = 200;
